import initialStates from '../hydratedInitialStates';

const initialState = initialStates.initialSettingsData;

const settings = (state = initialState) => state;

export default settings;
